// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3892":"ddc547c6","7708":"41ae0423","7729":"8a48a178"}[chunkId] + ".chunk.css";
};